import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carApplications/shdd_final/taskPage',
    method: 'post',
    data,
  })
}

export async function approval(data) {
    return request({
      url: '/v2/carApplications/shdd_final/taskCheck',
      method: 'post',
      data,
    })
}